import Vue from 'vue'
import store from 'store'

export default (el) => Promise.all([]).then(() => new Vue({
  el,
  store,
  data () {
    return {
      isActive: false,
      show: false,
      announcementBlocks: [],
      currentIndex: 0
    }
  },
  mounted () {
    if (!this.$el || !this.$el.dataset) return

    this.announcementBlocks = this.$el.dataset.blocks
      ? JSON.parse(this.$el.dataset.blocks)
      : []

    if (this.$el.dataset.active) {
      this.isActive = this.$el.dataset.active
    }
    this.startCarousel()

    if (this.isActive === 'true') {
      this.show = true
    }
  },
  beforeDestroy () {
    clearInterval(this.carouselInterval)
  },
  methods: {
    // Method to close the announcement banner
    close () {
      this.show = false
      const divElement = document.querySelector('.js-header')
      divElement.classList.add('top-banner-hide')
    },
    startCarousel () {
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.announcementBlocks.length
      }, 4000)
    }
  }
}))
